import {
  Bold,
  Essentials,
  FontBackgroundColor,
  FontColor,
  Heading,
  Image,
  ImageCaption,
  ImageResize,
  ImageStyle,
  ImageTextAlternative,
  ImageToolbar,
  ImageUpload,
  Italic,
  LegacyList,
  LegacyTodoList,
  Link,
  LinkImage,
  Paragraph,
  Table,
  Underline,
} from 'ckeditor5'

/**
 * We're using LegacyList and LegacyTodoList plugins at the moment,
 * as implementing new plugins will break opening CKEditor which contains todo list elements.
 * When we decide to move forward to implement new plugins, we should be careful
 * and fully test it before deploying a change and review src/plugins/converters/checkboxes.ts adapter.
 */

export type CorePluginName =
  | 'Bold'
  | 'Essentials'
  | 'FontBackgroundColor'
  | 'FontColor'
  | 'Heading'
  | 'Image'
  | 'ImageCaption'
  | 'ImageResize'
  | 'ImageStyle'
  | 'ImageTextAlternative'
  | 'ImageToolbar'
  | 'ImageUpload'
  | 'Italic'
  | 'Link'
  | 'LinkImage'
  | 'LegacyList'
  | 'Paragraph'
  | 'Table'
  | 'LegacyTodoList'
  | 'Underline'

export {
  Bold,
  Essentials,
  FontBackgroundColor,
  FontColor,
  Heading,
  Image,
  ImageCaption,
  ImageResize,
  ImageStyle,
  ImageTextAlternative,
  ImageToolbar,
  ImageUpload,
  Italic,
  Link,
  LinkImage,
  LegacyList,
  Paragraph,
  Table,
  LegacyTodoList,
  Underline,
}

export const CorePluginNames: CorePluginName[] = [
  'Bold',
  'Essentials',
  'FontBackgroundColor',
  'FontColor',
  'Heading',
  'Image',
  'ImageCaption',
  'ImageResize',
  'ImageStyle',
  'ImageTextAlternative',
  'ImageToolbar',
  'ImageUpload',
  'Italic',
  'Link',
  'LinkImage',
  'LegacyList',
  'Paragraph',
  'Table',
  'LegacyTodoList',
  'Underline',
]

export const CorePlugins = [
  Bold,
  Essentials,
  FontBackgroundColor,
  FontColor,
  Heading,
  Image,
  ImageCaption,
  ImageTextAlternative,
  ImageToolbar,
  ImageUpload,
  Italic,
  Link,
  LegacyList,
  Paragraph,
  Table,
  LegacyTodoList,
  ImageResize,
  ImageStyle,
  LinkImage,
  Underline,
]
